import { IHpSob } from 'legacy/lut/classes/models/partner360/ELT/financialData/hpSob/IHpSob'
import {
  ELT_FORM_SECTION,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getFormedChangedComplexData } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedChangedCompexData'
import { useCallback, useMemo } from 'react'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { ForceUpdate } from '../../styledComponents/forceUpdate/ForceUpdate'
import { HpSobNote } from '../../styledComponents/notes/HpSobNote'
import { StyledTable } from '../../styledComponents/styledTable/StyledTable'
import { Title } from '../../styledComponents/title/Title'

import { getHpSobColumns } from './helpers/getHpSobColumns'

import styles from './HpSob.module.scss'

interface IProps {
  fYear: number
  fQuarter: number
  data: IHpSob[]
  updateFormData: (data: TComplexSectionData) => void
  forceUpdate: (section: ELT_FORM_SECTION) => void
}

export const HpSob = ({ data, updateFormData, forceUpdate, fYear, fQuarter }: IProps) => {
  const onHpSobChange = useCallback(
    (index: number, cIndex: number, changedField: string) => (value: string | number | null) => {
      const hpSobCategoriesData = data[index].CategoriesData
      const item = hpSobCategoriesData[cIndex]

      item[changedField] = Number(value)

      const newData = getFormedChangedComplexData<IHpSob>({
        field: 'CategoriesData',
        value: hpSobCategoriesData,
        index,
        data,
      })
      updateFormData(newData)
    },
    [data, updateFormData]
  )

  const columns = useMemo(
    () =>
      getHpSobColumns({
        onHpSobChange,
        currentYear: fYear,
        currentFQuarter: fQuarter,
      }),
    [fYear, onHpSobChange, fQuarter]
  )

  const headerGroups = useMemo(() => {
    const previousFYear = fYear - 1

    return [
      { name: '', colspan: 2, withoutBorder: true },
      { name: previousFYear.toString(), colspan: 4 },
      { name: fYear.toString(), colspan: 4 },
    ]
  }, [fYear])

  return (
    <div className={styles.root}>
      <Title
        noteContent={() => <HpSobNote fYear={fYear} fQuarter={fQuarter} />}
        variant="withBackground"
        text={getFormedEltTranslation('section-hp-sob')}
        rightContent={
          <ForceUpdate isIcon onClick={forceUpdate} section={ELT_FORM_SECTION.HP_SOB} />
        }
      />

      <StyledTable<IHpSob>
        columns={columns}
        items={data}
        classes={{ td: styles.td, tr: styles.tr, header: styles.tableHeader }}
        headerGroups={headerGroups}
      />
    </div>
  )
}
